module.exports = __webpack_public_path__ + "static/media/Ankur-Vora.8c95dea0.jpg";